import { Model } from '@vuex-orm/core'

export default class Opening extends Model {
  static entity = 'openings'

  // static primaryKey = ['slab_id', 'id']

  static fields () {
    return {
      id: this.string(''),
      // project_id: this.number(0),
      slab_id: this.string(''),
      opening_type_id: this.number(1),
      // sequence: this.number(1),
      data: this.attr({
        XPositionLeftUpper: 300,
        YPositionLeftUpper: 560,
        OffsetX: 150,
        OffsetY: 240
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/models/Opening.js